
module Shared {  
    export class UtrNumber  {
        public utrReceived: boolean = null;
        public utrNumber: string = null;
    }
}
